import React, { useEffect, useState } from "react"
import { GridStack } from "gridstack";
import { useTranslation } from 'react-i18next';
import { useLocation } from "react-router-dom";
import DMSHeader from "../DMSHeader/DMSHeader";
import GridItem from "../../../Components/UiComponents/GridItem/GridItem";
import AccidentHistoryTable from "./AccidentHistoryTable";

const AccidentsHistory = () => {
    const { t } = useTranslation();
    const { state } = useLocation();
    const [currentTab, setCurrentTab] = useState('create');
    const [isEditMode, setIsEditMode] = useState(false);
    let edit = state?.edit;
    let data = state?.data;

    useEffect(() => {
        GridStack.init();

        // Set edit mode if edit state is present
        if (edit && data) {
            setIsEditMode(true);
            setCurrentTab('assign');
        }
    }, [edit, data]);

    

   

    // Determine header title based on current tab and edit mode
    const getHeaderTitle = () => {
        if (isEditMode && currentTab === 'assign') {
            return t("Edit Assigned Route");
        }

        switch (currentTab) {
            case 'create':
                return t("Accidents History");
            case 'assign':
                return t("Assign Route");
            case 'list':
                return t("Route List");
            default:
                return t("Accodents History");
        }
    };
console.log("getHeaderTitle",getHeaderTitle)
    const layoutData = [
        {
            x: 0,
            y: 0,
            width: 12,
            height: 1,
            id: 0,
            component: (
                <DMSHeader
                    title={"Accidents History"}
                    showIconsForback={edit || isEditMode}
                    showdownload={true}
                    fileName="Accidents History"
                />
            ),
            haveOverflowVisible: true,
        },
        {
            x: 0,
            y: 1,
            width: 12,
            height: 11,
            id: 1,
            component: (
                <AccidentHistoryTable
                    // onTabChange={handleTabChange}
                    // onEditModeChange={handleEditModeChange}
                />
            ),
        },
    ];

    return (
        <div className="grid-stack grid-stack-instance-1 smartpole__header--transition ">
            <GridItem layoutData={layoutData} />
        </div>
    );
}

export default AccidentsHistory;